import Vue from 'vue'
import { SidebarMenu } from 'vue-sidebar-menu'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'

Vue.component('sidebar-menu', SidebarMenu)
Vue.use(SidebarMenu)
